import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import HomeRoute from "./routes/index.jsx";
import AboutusRoute from "./routes/about-us.jsx";
import PhiloRoute from "./routes/philo.jsx";
import PhiloRoute1 from "./routes/philo1.jsx";
import PhiloRoute2 from "./routes/philo2.jsx";
import PhiloRoute3 from "./routes/philo3.jsx";
import PhiloRoute4 from "./routes/philo4.jsx";
import PhiloRoute5 from "./routes/philo5.jsx";
import PhiloRoute6 from "./routes/philo6.jsx";
import PhiloRoute7 from "./routes/philo7.jsx";
import LeadershipRoute from "./routes/leadership.jsx";
import HospitalityRoute from "./routes/Hospitality.jsx";
import HospitalityRoute1 from "./routes/Hospitality1.jsx";
import ContactRoute from "./routes/contact.jsx";
import LogiRoute from "./routes/LogiRoute.jsx";
import ThreeRoute from "./routes/ThreeRoute.jsx";
import { store } from "./services/store";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";

const router = createBrowserRouter([
  {
    path: "/",
    element: <HomeRoute />,
  },
  {
    path: "/about-us",
    element: <AboutusRoute />,
  },
  {
    path: "/contact",
    element: <ContactRoute />,
  },
  {
    path: "/investment-philosophy",
    element: <PhiloRoute />,
  },
  {
    path: "/corporate-responsibility",
    element: <PhiloRoute1 />,
  },
  {
    path: "/leadership",
    element: <LeadershipRoute />,
  },
  {
    path: "/industries/hospitality",
    element: <HospitalityRoute />,
  },
  {
    path: "/industries/infrastructure",
    element: <HospitalityRoute1 />,
  },
  {
    path: "/industries/logistics",
    element: <LogiRoute />,
  },
  {
    path: "/industries/real-estate",
    element: <PhiloRoute2 />,
  },
  {
    path: "/industries/foreign-direct-investment",
    element: <PhiloRoute3 />,
  },
  {
    path: "/industries/aviation",
    element: <PhiloRoute4 />,
  },
  {
    path: "/industries/ports",
    element: <PhiloRoute5 />,
  },
  {
    path: "/industries/education",
    element: <PhiloRoute6 />,
  },
  {
    path: "/industries/industrial",
    element: <PhiloRoute7 />,
  },
  {
    path: "/three",
    element: <ThreeRoute />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <RouterProvider router={router} />
  </Provider>
);
